"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var R = require('ramda');
/**
 * Element builder
 * @module
 * @param {Array} rules - array of rules
 * @param {Object} data - json data
 * @param {Object} fields - map of fields
 **/


module.exports = function (rules, data) {
  var fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return rules.reduce(rule(json(data), fields), {});
};

var json = function json(d) {
  return trim(d.constructor === Object ? d : JSON.parse(d));
},
    trim = function trim(d) {
  return Object.keys(d).reduce(function (d, k) {
    if (typeof d[k] === 'string') d[k] = d[k].trim();else if (d[k] && d[k].constructor === Object) trim(d[k]);
    return d;
  }, d);
},
    rule = function rule(d, F) {
  return function (e, r) {
    return r.fields.filter(function (f) {
      return !d.__fields || d.__fields.includes(f);
    }).reduce(validators(r, d, F), e);
  };
},
    validators = function validators(r, d, F) {
  return function (e, f) {
    return [].concat(_toConsumableArray(r.required ? [isEmpty] : []), _toConsumableArray(r.validators || [])).reduce(validator(r, d, F, f), e);
  };
},
    validator = function validator(r, d, F, f) {
  return function (e, v) {
    var val = value(d, F, f);
    return r.required || v.constructor === Function || val !== undefined ? type(v)(val, f, d, r) ? e : error(e, r, f) : e;
  };
},
    value = function value(d, F, f) {
  return F.hasOwnProperty(f) ? R.path(F[f], d) : d[f];
},
    error = function error(e, r, f) {
  return _objectSpread(_objectSpread({}, e), {}, _defineProperty({}, f, e[f] ? (e[f].includes(r.name) || e[f].push(r.name)) && e[f] : [r.name]));
},
    type = function type(f) {
  return ({
    isArray: isArray,
    isRegExp: isRegExp,
    isFunction: isFunction
  }["is".concat(f.constructor.name)] || isString)(f);
},
    isEmpty = function isEmpty(v) {
  return !['', undefined, null, NaN].includes(v);
},
    isArray = function isArray(a) {
  return function (v) {
    return a.filter(function (a) {
      return "".concat(a) === "".concat(v);
    }).length;
  };
},
    isString = function isString(s) {
  return isArray([s]);
},
    isRegExp = function isRegExp(r) {
  return function (v) {
    return r.test(v);
  };
},
    isFunction = function isFunction(f) {
  return f;
};
